import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";


type ProductCodeFilterProps = {
  onChange: (value: string[]) => void;
  value?: string[];
};

export const MachineLicenseOptionFilter: React.FC<ProductCodeFilterProps> = ({
  value,
  onChange,
}) => {
  const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
  const { t } = useTranslation();
  //const {allMachineLicenseOptions} = ;

  const statusOptions = [
    { label: t("machinelicenses.create.form.monthly"), value: "MONTHLY" },
    { label: t("machinelicenses.create.form.yearly"), value: "YEARLY" },

  ]
  return (
    <SelectBoxWrapper>
      <Select
        mode="multiple"
        allowClear
        placeholder={t("machinelicenses.list.columns.level")}
        style={{ width: "100%" }}
        maxTagCount={1}
        options={statusOptions}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};
